// src/components/common/OrderNumberBadge.jsx
import React from "react";
import { useColor } from "../../hooks/color/useColor";
import { FiWifi, FiWifiOff } from "react-icons/fi";

const OrderNumberBadge = ({
  orderNumber,
  orderType,
  onClick,
  dataNotooltip = "false",
  style = {},
  className = "text-xs px-2.5 py-1 rounded font-semibold shadow-md hover:scale-105 transition-transform border border-black flex items-center",
}) => {
  const { getColor } = useColor();

  // Get the icon based on order type
  const getIcon = () => {
    const orderTypeLower = (orderType || "").toLowerCase();
    
    if (orderTypeLower.includes("offline") || orderTypeLower === "offline") {
      return <FiWifiOff className="inline-block mr-1 text-red-600" />;
    } else if (orderTypeLower.includes("online") || orderTypeLower === "online") {
      return <FiWifi className="inline-block mr-1 text-green-600" />;
    }
    
    // Default: show # for unknown types
    return "#";
  };

  return (
    <button
      data-no-tooltip={dataNotooltip}
      onClick={onClick}
      className={`${className} text-black`}
      style={{
        backgroundColor: getColor("orderStatus", orderType),
        ...style,
      }}
      title={`View Order #${orderNumber || "PENDING"}`}
    >
      {getIcon()}
      {orderNumber || "PENDING"}
    </button>
  );
};

export default OrderNumberBadge;